import React, { useRef } from 'react';
import {
  Dialog,
  Box,
  useMediaQuery,
  useTheme,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Close as CloseIcon } from '@mui/icons-material';

type PdfViewerDialogProps = {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
};

const PdfViewer: React.FC<PdfViewerDialogProps> = ({
  open,
  onClose,
  pdfUrl,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Dialog
      sx={{ mt: isMobile ? '-200px' : 6 }}
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={onClose}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: isMobile ? '132px' : '240px',
            top: '-5px',
          }}
        >
          <CloseIcon sx={{ color: '#000000' }} />
        </IconButton>

        <iframe
          ref={iframeRef}
          title="document provider"
          src={pdfUrl}
          style={{
            width: '100%',
            height: isMobile ? '500px' : '600px',
            border: 'none',
          }}
        />
      </Box>
    </Dialog>
  );
};

export default PdfViewer;
